var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-select',{attrs:{"value":_vm.selected},on:{"change":_vm.handleChange}},_vm._l((_vm.options),function(o){return _c('a-select-option',{key:o.label,attrs:{"value":o.id}},[_vm._v(" "+_vm._s(o.label)+" ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }